export const getDateRange = (dateDiff) => {
  // Get the current date
  var currentDate = new Date();

  // Get the date before 15 days
  var before15Days = new Date();
  before15Days.setDate(currentDate.getDate() - dateDiff);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split('T')[0];
  var before15DaysStr = before15Days.toISOString().split('T')[0];
  return [before15DaysStr, currentDateStr]
}

const getBaseImage = (images) => {
  for (let i = 0; i < images?.length; i++) {
    if (images[i]?.baseImage) {
      return images[i].image;
    }
  }
  return images?.length > 0 ? images[0]?.image : "";
};

const removeSpacesFromName = (data) => {
  if (data === undefined || data === "" || data === null)
    return "";
  return data.replace(/\s+/g, '');
}


// sl - 712
const roundOfftoTwoDecimals = (num) => {
  if(num === undefined || num === "" || num === null) return ""
  return Math.round(num * 100) / 100;
}

const profileMimeExtensions = {
  "image/jpeg": ".jpg",
  "image/png": ".png",
  "image/webp": ".webp",
  "image/gif": ".gif",
  "image/bmp": ".bmp",
  "image/svg+xml": ".svg",
  "application/pdf": ".pdf"
};

const isFileExtensionValid = (fileName, validExtensions) => {
  const fileNameLower = fileName.toLowerCase();
  return validExtensions.some(ext => fileNameLower.endsWith(ext));
}

export const GenUtilities = {
  getDateRange,
  getBaseImage,
  removeSpacesFromName,
  roundOfftoTwoDecimals,
  profileMimeExtensions,
  isFileExtensionValid
}